exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".left__content {\n  flex: 1 0 50%; }\n\n.right__content {\n  display: flex;\n  flex-direction: row;\n  height: fit-content;\n  justify-content: flex-end;\n  flex: 1 0 50%; }\n\n.split__content {\n  flex-wrap: wrap;\n  display: flex;\n  justify-content: space-between; }\n\n.printer__img {\n  max-width: 420px;\n  width: 100%; }\n\n@media (min-width: 833px) {\n  .printer__img {\n    position: fixed; } }\n\n@media (max-width: 832px) {\n  .split__content {\n    flex-flow: column-reverse; } }\n\n.section__card {\n  background-color: white;\n  border-radius: 13px;\n  padding: 16px 16px;\n  width: 100%;\n  margin: 24px auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Help/StarConnect/index.scss
// module id = 6530
// module chunks = 1